import axios from "axios";

export const PositionParser = {

  parse(response) {
    let view = new DataView(response);

    let confByte = view.getUint8(0);

    // check config switches
    let doAltitude = ((confByte & 0x01) === 0x01);
    let doDTF = ((confByte & 0x02) === 0x02);
    let doLaps = ((confByte & 0x04) === 0x04);
    let doPcComplete = ((confByte & 0x08) === 0x08);

    let startOff = view.getUint32(1);

    let cursor = 5;

    let data = [];

    while (cursor < response.byteLength) {

      // read first 2 bytes - this is the team id
      let teamId = view.getUint16(cursor);
      cursor += 2;

      let numberOfPositions = view.getUint16(cursor);

      let teamMoments = new Array(numberOfPositions);

      cursor += 2;

      let lastMoment;

      for (let i = 0; i < numberOfPositions; i++) {

        let firstByte = view.getUint8(cursor);

        let moment = {};

        if ((firstByte & 0x80) === 0x80) {
          // relative mode
          let atDelta = view.getUint16(cursor);
          cursor += 2;
          let latDelta = view.getInt16(cursor);
          cursor += 2;
          let lonDelta = view.getInt16(cursor);
          cursor += 2;

          if (doAltitude) {
            moment.alt = view.getInt16(cursor);
            cursor += 2;
          }

          if (doDTF) {
            // expecting a 2-byte short, in metres
            let dtfDelta = view.getInt16(cursor);
            cursor += 2;
            moment.dtf = lastMoment.dtf + dtfDelta;

            if (doLaps) {
              moment.lap = view.getUint8(cursor);
              cursor++;
            }

          }

          if (doPcComplete) {

            moment.pc = view.getInt16(cursor) / 32000;
            cursor += 2;

          }


          atDelta = atDelta & 0x7fff;

          moment.lat = lastMoment.lat + latDelta;
          moment.lon = lastMoment.lon + lonDelta;
          moment.at = lastMoment.at - atDelta;
          moment.pc = lastMoment.pc + moment.pc;

        } else {
          // absolute mode

          let at = view.getUint32(cursor);
          cursor += 4;
          let lat = view.getInt32(cursor);
          cursor += 4;
          let lon = view.getInt32(cursor);
          cursor += 4;

          if (doAltitude) {
            moment.alt = view.getInt16(cursor);
            cursor += 2;
          }


          if (doDTF) {
            // expecting a 4-byte int, in metres
            let dtf = view.getInt32(cursor);
            cursor += 4;
            moment.dtf = dtf;

            if (doLaps) {
              moment.lap = view.getUint8(cursor);
              cursor++;
            }

          }

          if (doPcComplete) {

            moment.pc = (view.getInt32(cursor) / 21000000);
            cursor += 4;

          }

          moment.lat = lat;
          moment.lon = lon;
          moment.at = startOff + at;

        }

        teamMoments[i] = moment;
        lastMoment = moment;
      }

      teamMoments.forEach(m => {
        m.lat /= 100000;
        m.lon /= 100000;
      });

      data.push({
        id: teamId, moments: teamMoments
      });
    }

    return data;
  },

  requestAll(server, race) {

    return axios({
      method: 'get', responseType: 'arraybuffer', url: `//${server}/BIN/${race}/AllPositions3`
    }).then((response) => {

      return this.parse(response.data);

    });

  }
};